export default "__VITE_ASSET__BaZe_meZ__"